export const GET_NOTIFICATIONS = gql`
  query Notifications(
    $pageInfo: PageInfoInput
    $filters: NotificationsFiltersInput
  ) {
    notifications(pageInfo: $pageInfo, filters: $filters) {
      totalCount
      items {
        notificationId
        createdAt
        updatedAt
        type
        employeeId
        title
        message
        read
        taskId
        task {
          taskId
          status
        }
        applicant {
          applicantId
          firstName
          lastName
        }
        voe {
          voeId
        }
        activityLog {
          activityLogId
          voiceAgent {
            voiceAgentId
          }
          documents {
            documentId
            status
            fileName
          }
        }
        company {
          companyId
          companyName
        }
      }
    }
  }
`

export const MARK_AS_READ = gql`
  mutation MarkAsRead($id: String!) {
    markAsRead(id: $id)
  }
`

export const MARK_NOTIFICATIONS_AS_READ = gql`
  mutation MarkNotificationsAsRead($input: MarkNotificationsAsReadInput!) {
    markNotificationsAsRead(input: $input) {
      count
    }
  }
`

export const REPLY_SMS = gql`
  mutation ReplySMS($id: String!, $message: String!) {
    replySMS(id: $id, message: $message)
  }
`
